import Splide from "@splidejs/splide";

export function initNewsSlider() {
	const newsSection = document.querySelector(".news-section");
	const newsSlider = document.querySelector("#news-slider");
	const btnCollapse = document.querySelector(".news-section .collapse-btn");

	if (!newsSlider) {
		return;
	}

	const currentSlideEl = newsSlider.querySelector(".current-slide");
	const nextArrow = newsSlider.querySelector(".next-arrow");

	const splide = new Splide(newsSlider, {
		type: "fade",
		autoplay: true,
		interval: 6000,
		speed: 1800,
		pauseOnHover: true,
		pauseOnFocus: true,
		arrows: false,
		pagination: false,
		perPage: 1,
		gap: 0,
		rewind: true,
	});

	if (btnCollapse) {
		btnCollapse.addEventListener("click", () => {
			newsSection.classList.toggle("collapsed");
			btnCollapse.children[0].classList.toggle("rotate");
		});
	}

	// Update counter when slide changes
	const updateCounter = () => {
		if (currentSlideEl) {
			// Get the current index (0-based) and convert to 1-based
			const currentIndex = splide.index + 1;
			currentSlideEl.textContent = currentIndex;
		}
	};

	if (nextArrow) {
		nextArrow.addEventListener("click", () => {
			splide.go("+1");
		});
	}

	splide.on("moved", updateCounter);
	splide.on("ready", updateCounter);

	splide.mount();
}
